module.exports = __webpack_public_path__ + "static/media/back_icon.d15c01c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back_icon.svg
// module id = 253
// module chunks = 0